import {createContext} from 'react'

// Undefined preserves unscoped surfaces; null means a scoped conversation whose
// authoritative owner has not resolved, never permission to search all owners.
export const ComposerAttachmentScopeContext = createContext<string | null | undefined>(undefined)
